module.exports = __webpack_public_path__ + "media/slider/Subscription-1-IND-3283987f.jpg";